import { choose } from '../utils/platform';
import ReportShareDesktop from './ReportShare.desktop';
import ReportShareMobile from './ReportShare.mobile';

// Platform chooser: phone (APK or narrow browser) gets the big-button sheet.
export default choose(ReportShareDesktop, ReportShareMobile);
